import { useSearchParams } from 'react-router-dom';

export const useGetParams = () => {
  const [searchParams] = useSearchParams();
  let phoneNumber = searchParams.get('phoneNumber');

  if (phoneNumber) {
    let textNumber;
    textNumber = phoneNumber
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/"/g, '&quot;');
    if (textNumber[0].match(/\s/)) {
      textNumber = textNumber.replace(/\s/, '+');
    }
    phoneNumber = textNumber;
  }

  return {
    user: searchParams.get('user') || '',
    bgVideo: searchParams.get('bgVideo') || '1',
    bgPoster: searchParams.get('bgPoster') || null,
    phoneNumber,
    title: searchParams.get('title'),
    socials: searchParams.get('socials'),
    qrTitle1: searchParams.get('qrTitle1'),
    qrCode1: searchParams.get('qrCode1'),
    qrTitle2: searchParams.get('qrTitle2'),
    qrCode2: searchParams.get('qrCode2'),
    startFrom: searchParams.get('startFrom')
      ? parseInt(searchParams.get('startFrom') || '')
      : 2,
    duration: searchParams.get('duration')
      ? parseInt(searchParams.get('duration') || '')
      : 3630,
    carousel: searchParams.get('carousel') || '0',
    repeatCount: parseInt(searchParams.get('repeatCount') || '') || 10,
    speedSlow: searchParams.get('speedSlow')
      ? parseInt(searchParams.get('speedSlow') || '')
      : 670,
    phoneNumberFontSize: searchParams.get('phoneNumberFontSize') || '3.125',
    titleFontSize: searchParams.get('titleFontSize') || '2.5',
    sizeQR: searchParams.get('sizeQR') || '27',
    paddingQR: searchParams.get('paddingQR') || '0',
  };
};
